/* RESPONSIBLE TEAM: team-messenger */
import ApplicationAdapter from '../application';

export default ApplicationAdapter.extend({
  pathForType() {
    return 'messenger_home/slot_groups';
  },
});
